import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

import * as types from '../actionTypes';

export const gatesAdapter = createEntityAdapter({ selectId: ({ id }) => id });

const updateGateOpenings = (state, { payload }) => {
  const { gateId, content = [], lastSk, isAppend } = payload;
  const existingHistory = isAppend ? (state.entities[gateId]?.history || []) : [];
  const history = [...existingHistory, ...content];

  return gatesAdapter.updateOne(state, { id: gateId, history, lastSk });
};

/** @typedef {import('../types').Gate} Gate */

/**
 * @typedef {import('utils/ReduxUtils').EntityState<Gate>} GatesDataEntity
 */
export default createReducer(gatesAdapter.getInitialState(), {
  [types.FETCH_GATES_SUCCESS]: (state, { payload }) => gatesAdapter.updateMany(state, payload.content),
  [types.FETCH_AVAILABLE_GATES_SUCCESS]: (state, { payload }) => gatesAdapter.updateMany(state, payload.content),
  [types.FETCH_GATE_SUCCESS]: gatesAdapter.addOne,
  [types.CREATE_GATE_SUCCESS]: gatesAdapter.addOne,
  [types.UPDATE_GATE_SUCCESS]: gatesAdapter.addOne,
  [types.DELETE_GATE_SUCCESS]: gatesAdapter.removeOne,
  [types.FETCH_GATE_OPENINGS_SUCCESS]: updateGateOpenings,
});
